import script from "./PopUpTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./PopUpTemplate.vue?vue&type=script&setup=true&lang=js"

import "./PopUpTemplate.vue?vue&type=style&index=0&id=3d4df9b5&lang=css"

const __exports__ = script;

export default __exports__